import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CCTable } from "components/ui/Table";
import { checkForDisbursementDates } from "./checkForDisbursementDates";
import formatCurrency from "functions/formatCurrency";
import ButtonAsLink from "components/ui/ButtonAsLink";
import InfoIcon from "components/ui/InfoIcon";
import { VisuallyHidden } from "components/ui/VisuallyHidden";

export function DisbursementTable({
  termDetails,
  messageEstDisbursements,
  showDecimals,
}) {
  const [showNote, setShowNote] = useState(false);
  const columnTitle = checkForDisbursementDates(termDetails);
  const isEstimated = columnTitle === "Est. Disbursement";

  if (termDetails.length > 0) {
    return (
      <>
        <DisbursementTableStyles>
          <thead>
            <tr>
              <th scope="col">
                {columnTitle}{" "}
                {isEstimated && !showNote && (
                  <ButtonAsLink onClick={() => setShowNote(true)}>
                    <InfoIcon />
                    <VisuallyHidden>
                      What is Estimated Disbursement?
                    </VisuallyHidden>
                  </ButtonAsLink>
                )}
              </th>
              <th scope="col">Offered</th>
              <th scope="col">Disbursed</th>
            </tr>
          </thead>
          <tbody>
            {termDetails.map((termDetail) => (
              <TermDetail
                key={termDetail.disbursementid}
                termDetail={termDetail}
                showDecimals={showDecimals}
              />
            ))}
          </tbody>
        </DisbursementTableStyles>

        {showNote && (
          <>
            <div style={{ paddingTop: `5px` }}>{messageEstDisbursements}</div>
            <div>
              <ButtonAsLink onClick={() => setShowNote(false)}>
                Show less
              </ButtonAsLink>
            </div>
          </>
        )}
      </>
    );
  }

  return null;
}

DisbursementTable.displayName = "DisbursementTable";
DisbursementTable.propTypes = {
  termDetails: PropTypes.array,
  messageEstDisbursements: PropTypes.string,
  showDecimals: PropTypes.bool,
};

function TermDetail({ termDetail, showDecimals }) {
  return (
    <tr>
      <td>
        <div style={{ display: `flex` }}>
          <div style={{ flex: `0.75` }}>{termDetail.term}</div>
          <div>{termDetail.disbursementDate}</div>
        </div>
      </td>
      <td>{formatCurrency(termDetail.offered, { showDecimals })}</td>
      <td>{formatCurrency(termDetail.disbursed, { showDecimals })}</td>
    </tr>
  );
}

TermDetail.displayName = "TermDetail";
TermDetail.propTypes = {
  termDetail: PropTypes.shape({
    term: PropTypes.string,
    disbursementDate: PropTypes.string,
    offered: PropTypes.number,
    disbursed: PropTypes.number,
  }),
  showDecimals: PropTypes.bool,
};

const DisbursementTableStyles = styled(CCTable)`
  thead,
  tbody {
    tr {
      th,
      td {
        text-align: right;
      }
    }

    tr {
      th,
      td {
        &:first-child {
          text-align: left;
        }
      }
    }
  }
`;
